/*
 * @Author: honghong
 * @LastEditors: honghong
 * @Description: app入口
 * @email: 3300536651@qq.com
 * @Date: 2019-02-18 10:44:05
 * @LastEditTime: 2019-04-17 10:16:54
 */
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent {
}
